var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos:facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3337 10.0503C18.3337 5.4198 14.6027 1.66602 10.0003 1.66602C5.39798 1.66602 1.66699 5.41974 1.66699 10.0503C1.66699 14.2351 4.71439 17.7037 8.69824 18.3327V12.4738H6.58236V10.0503H8.69824V8.20312C8.69824 6.10181 9.94238 4.94112 11.8458 4.94112C12.7576 4.94112 13.7113 5.10487 13.7113 5.10487V7.16818H12.6605C11.6252 7.16818 11.3024 7.81449 11.3024 8.47757V10.0503H13.6136L13.2441 12.4738H11.3024V18.3327C15.2863 17.7037 18.3337 14.2351 18.3337 10.0503Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.8968 12.4434L13.2423 10.0485H11.081V8.4945C11.081 7.83922 11.3829 7.20065 12.351 7.20065H13.3337V5.16181C13.3337 5.16181 12.4418 5 11.5892 5C9.80915 5 8.64568 6.14693 8.64568 8.2233V10.0485H6.66699V12.4434H8.64568V18.2327C9.04849 18.2998 9.45561 18.3334 9.86334 18.3333C10.2711 18.3335 10.6782 18.2998 11.081 18.2327V12.4434H12.8968Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosFacebook);
export default __webpack_public_path__ + "static/media/logos_facebook.a339ca8aad2a268d560dfc4b1d52553d.svg";
export { ForwardRef as ReactComponent };